<app-page-meta pageTitle="Finzy Flex"></app-page-meta>
<app-header></app-header>

<div class="page-wrapper">
    <div class="menu-wrapper">
        <app-flex-menu></app-flex-menu>
        <section *ngIf="showQuickSetup" class="quick-setup">
            <app-quick-setup
            [isSwiftOn]="isSwiftOn"
            [isNCashOn]="isNCashOn"
            [userAttributes]="userAttributes"
            ></app-quick-setup>
        </section>
    </div>
    <div class="page-container">
        <router-outlet></router-outlet>
    </div>
</div>

<app-footer></app-footer>